import React from 'react'
import Container from '../components/Container'



const Home = () => {
   
   
  return (
    <Container>
    </Container>
  )
}

export default Home